import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-property-decorator";
import { store } from "store";
import axios from "axios";
var InviteSponsorView = /** @class */ (function (_super) {
    tslib_1.__extends(InviteSponsorView, _super);
    function InviteSponsorView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.status = null;
        _this.error = null;
        _this.store = store;
        _this.sponsors = [_this.createEmptySponsor()];
        _this.sponsorlink = "";
        _this.sponsorCopied = false;
        return _this;
    }
    InviteSponsorView.prototype.routed = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        store.page.title = this.$t("inviteSponsorView.title");
                        store.page.showTopNav = true;
                        _a = this;
                        return [4 /*yield*/, axios.get("sponsors/joinlink/" + store.selectedEvent.eventParticipant.eventParticipantId)];
                    case 1:
                        _a.sponsorlink = (_b.sent()).data;
                        return [2 /*return*/];
                }
            });
        });
    };
    InviteSponsorView.prototype.addRecipient = function () {
        this.sponsors.push(this.createEmptySponsor());
    };
    InviteSponsorView.prototype.inviteViaEmail = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var invitedSponsors, emails, result, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.status = "Sending";
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        invitedSponsors = [];
                        invitedSponsors = this.sponsors
                            .map(function (s) { return (tslib_1.__assign({}, s, { email: s.email.trim(), invitedOn: new Date(Date.now()) })); })
                            .filter(function (s) { return s.email; });
                        emails = invitedSponsors.map(function (s) { return s.email; });
                        return [4 /*yield*/, axios.post("sponsors/invite-email", { eventId: this.store.selectedEvent.eventId, emails: emails })];
                    case 2:
                        result = (_b.sent()).data;
                        this.status = "Sent";
                        this.$set(store.selectedEvent, "sponsors", store.selectedEvent.sponsors.concat(invitedSponsors));
                        this.sponsors = [this.createEmptySponsor()];
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        this.error = this.$t("inviteSponsorView.emailInvitationFailed");
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    InviteSponsorView.prototype.createEmptySponsor = function (email) {
        if (email === void 0) { email = ""; }
        return {
            sponsorId: 0,
            firstname: "",
            lastname: "",
            fullName: "",
            sponsorType: "Private",
            companyName: null,
            email: email,
            payment: 0,
            notificationSentOn: null,
            numNotificationsSent: 0,
            participationStatus: "NotAnswered",
            shouldPay: null,
            paid: 0,
            estimatedPayment: null,
            paymentMethod: "Manual",
            billSentOn: null,
            eventParticipantId: 0,
            streetAddress: "",
            zipCode: "",
            city: "",
            sendingEmail: false,
            editingEmail: false,
            info: null,
            preferredBillingMethod: "Email",
        };
    };
    InviteSponsorView.prototype.isDuplicateEmail = function (email) {
        return store.selectedEvent.sponsors.find(function (s) { return s.email === email; }) != null;
    };
    InviteSponsorView.prototype.invitePreviousSponsors = function () {
        this.$router.push('/invite-previous-sponsors');
    };
    Object.defineProperty(InviteSponsorView.prototype, "isValidatedForSubmit", {
        get: function () {
            return this.sponsors.some(function (s) { return !!s.email; });
        },
        enumerable: true,
        configurable: true
    });
    InviteSponsorView.prototype.copySponsorLink = function () {
        var _this = this;
        this.$refs.text.select();
        document.execCommand('copy');
        this.sponsorCopied = true;
        setTimeout(function () {
            _this.sponsorCopied = false;
        }, 2000);
    };
    InviteSponsorView = tslib_1.__decorate([
        Component
    ], InviteSponsorView);
    return InviteSponsorView;
}(Vue));
export default InviteSponsorView;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./app/ts/views/InviteSponsorView.vue
// module id = 64
// module chunks = 0